import { render, staticRenderFns } from "./DigitalWallets.vue?vue&type=template&id=c8b30b3e&"
import script from "./DigitalWallets.vue?vue&type=script&lang=js&"
export * from "./DigitalWallets.vue?vue&type=script&lang=js&"
import style0 from "./DigitalWallets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports